import type { Selector } from "@reduxjs/toolkit";
import { createSelector } from "@reduxjs/toolkit";

import type { DrawingStoreState } from "./types";

const getDrawingStoreState: Selector<{ drawings: DrawingStoreState }, DrawingStoreState> = (state): DrawingStoreState => state.drawings;

// drawing details

export const getDrawingDetails = createSelector(getDrawingStoreState, (state) => state.drawingDetails);

export const getDrawingDetailsFetched = createSelector(getDrawingStoreState, (state) => state.drawingDetailsFetched);

export const getHasDrawingDetailsError = createSelector(getDrawingStoreState, (state) => state.hasDrawingDetailsError);

// coordinates

export const getDrawingCoordinates = createSelector(getDrawingStoreState, (state) => state.drawingCoordinates);

export const getCoordinatesFetched = createSelector(getDrawingStoreState, (state) => state.coordinatesFetched);

// drawing base

export const getDrawingIsFetching = createSelector(getDrawingStoreState, (state) => state.isFetching);

// part information

export const getDrawingPartInformation = createSelector(getDrawingStoreState, (state) => state.drawingPartInformation);

export const getDrawingPartInformationIsFetching = createSelector(getDrawingStoreState, (state) => state.isFetchingDrawingPartsInformation);

// misc

export const getCurrentMachine = createSelector(getDrawingStoreState, (state) => state.currentMachine);

// drawing image

export const getCurrentDrawing = createSelector(getDrawingStoreState, (state) => state.currentDrawing);

export const getCurrentDrawingPath = createSelector(getDrawingStoreState, (state) => state.currentDrawingPath);

// currently selected drawing part

export const getSelectedDrawingPart = createSelector(getDrawingStoreState, (state) => (state.selectedDrawingPart ? state.selectedDrawingPart : null));
